"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
/**
 * Unwrap items at range from their list.
 */
function unwrapList(opts, editor) {
    var items = utils_1.getItemsAtRange(opts)(editor.value);
    if (items.isEmpty()) {
        return editor;
    }
    return editor.withoutNormalizing(function () {
        // Unwrap the items from their list
        items.forEach(function (item) {
            editor.unwrapNodeByKey(item.key);
        });
        // Parent of the list of the items
        var firstItem = items.first();
        var parent = editor.value.document.getParent(firstItem.key);
        if (parent) {
            var index_1 = parent.nodes.findIndex(function (node) { return node.key === firstItem.key; });
            // Unwrap the items' children
            items.forEach(function (item) {
                item.nodes.forEach(function (node) {
                    editor.moveNodeByKey(node.key, parent.key, index_1);
                    index_1 += 1;
                });
            });
            // Finally, remove the now empty items
            items.forEach(function (item) {
                editor.removeNodeByKey(item.key);
            });
        }
    });
}
exports.default = unwrapList;
//# sourceMappingURL=unwrapList.js.map